export default "__VITE_ASSET__DjyR808t__"